import { Marker } from "react-map-gl/dist/maplibre"
import { calculateCoordFromPointWithDistance } from "@nova/calculate-geospatial"
import { ADSB_AREA_RADIUS_METERS } from "@nova/constants"
import { useAppSelector } from "integrations/redux/hooks"
import { selectAdsbCircleCenter, selectAdsbEnabled, selectAdsbIsPlacingCircle } from "../slice"

export const AdsbScanAreaLabel = () => {
    const enabled = useAppSelector(selectAdsbEnabled)
    const isPlacingCircle = useAppSelector(selectAdsbIsPlacingCircle)
    const center = useAppSelector(selectAdsbCircleCenter)

    if (!enabled || isPlacingCircle || !center) return null

    const [lng, lat] = calculateCoordFromPointWithDistance(
        [center.lng, center.lat],
        0,
        ADSB_AREA_RADIUS_METERS
    )

    return (
        <Marker longitude={lng} latitude={lat} anchor="bottom" offset={[0, -8]}>
            <div className="px-2 py-1 bg-gray-900 border border-gray-700 rounded-lg text-gray-50 text-xs whitespace-nowrap pointer-events-none">
                ADS-B Scan Area
            </div>
        </Marker>
    )
}
